export const ChatEntityLinkType = Object.freeze({
	tasks: 'TASKS',
	sonetGroup: 'SONET_GROUP',
	mail: 'MAIL',
	calendar: 'CALENDAR',
	contact: 'CONTACT',
	deal: 'DEAL',
	lead: 'LEAD',
	dynamic: 'DYNAMIC',
});
